<template>
  <b-card no-body>
    <b-card-header>
      <!-- title -->
      <b-card-title>{{ $t('confirmationsDonePerEvaluatorAndPerProcess') }}</b-card-title>

      <!-- dropdown -->
      <!-- <b-dropdown
        variant="link"
        toggle-class="p-0"
        no-caret
      >
        <template #button-content>
          <feather-icon
            class="text-body"
            icon="MoreVerticalIcon"
          />
        </template>
        <b-dropdown-item>
          Last 28 Days
        </b-dropdown-item>
        <b-dropdown-item>
          Last Month
        </b-dropdown-item>
        <b-dropdown-item>
          Last Year
        </b-dropdown-item>
      </b-dropdown> -->
      <!--/ dropdown -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        type="heatmap"
        :height="this.height"
        :options="heatMapChart.options"
        :series="this.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCardTitle, BDropdown, BDropdownItem } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import { EventBus } from "@/views/habit/EventBus.js"
import i18n from '@/libs/i18n'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    VueApexCharts,
    BCardTitle,
    BDropdown,
    BDropdownItem,
  },
  props: {
    confirmationsPerDayData: {
      type: Array,
      required: true,
    },
    commitmentFunctionality: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      heatMapChart: {
        options: {
          tooltip: {
            followCursor: false,
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              const processName = w.config.series[seriesIndex].data[dataPointIndex].processName
              return (
                `
                  <div style="padding: 10px">
                    <div>
                      <span>${i18n.t('tooltip.supervisor')}: </span>
                      <span style="font-weight: bold">${w.globals.seriesNames[seriesIndex]}</span>
                    </div>
                    <div>
                      <span>${i18n.t('tooltip.process')}: </span>
                      <span style="font-weight: bold">${processName}</span>
                    </div>
                    <div>
                      <span>${i18n.t('Realizadas')}: </span>
                      <span style="font-weight: bold">${series[seriesIndex][dataPointIndex]}</span>
                    </div>
                  </div>
                `
              )
            }
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#ffffff']
            }
          },
          legend: {
            show: false,
            // position: 'bottom',
          },
          // colors: ['#7367F0'],
          stroke: {
            width: 1,
            colors: ['#d3d3d3']
          },
          plotOptions: {
            heatmap: {
              enableShades: false,
              colorScale: {
                ranges: [
                  {
                    from: 0,
                    to: 0,
                    // name: '0-10',
                    color: '#ffffff',
                  },
                  // {
                  //   from: 1,
                  //   to: 1,
                  //   // name: '10-20',
                  //   color: this.commitmentFunctionality ? $themeColors.success : $themeColors.warning,
                  // },
                  {
                    from: 1,
                    to: 1000,
                    // name: '10-20',
                    color: $themeColors.success,
                  },
                ],
              },
            },
          },
          xaxis: {
            labels: {
              show: true,
              formatter: function(value, timestamp, index) {
                return value.length > 4 ? value.substr(0, 4) + '...' : value;
              }
            },
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: true,
            },
          },
          chart: {
            height: 350,
            type: 'heatmap',
            toolbar: {
              show: false,
            },
            events: {
              click: function(event, chartContext, config) {
                if (config.seriesIndex < 0 || config.dataPointIndex < 0) return
                const supervisorId = config.config.series[config.seriesIndex].supervisorId
                const processId = config.config.series[config.seriesIndex].data[config.dataPointIndex].processId
                EventBus.$emit("filterBySupervisorAndProcess", supervisorId, processId)
              },
              dataPointMouseEnter: function(event) {
                event.srcElement.style.cursor = "pointer"
              },
              mounted: function(chartContext, config) {
                const el = chartContext.el;
                const parent = el.parentNode;
                if (!parent) return;

                const tip = document.createElement('div');
                tip.style.position = 'absolute';
                tip.style.pointerEvents = 'none';
                tip.style.padding = '6px 8px';
                tip.style.borderRadius = '6px';
                tip.style.boxShadow = '0 4px 12px rgba(0,0,0,.15)';
                tip.style.background = 'rgba(255,255,255,.95)';
                tip.style.border = '1px solid rgba(0,0,0,0.08)';
                tip.style.font = '12px system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
                tip.style.whiteSpace = 'nowrap';
                tip.style.opacity = '0';
                tip.style.transition = 'opacity 0.1s';
                parent.style.position = 'relative';
                parent.appendChild(tip);

                const moveHandler = (evt) => {
                  const rect = el.getBoundingClientRect();
                  const mouseX = evt.clientX - rect.left;
                  const mouseY = evt.clientY - rect.top;

                  const xaxisLabels = chartContext.w.globals.dom.baseEl.querySelectorAll('.apexcharts-xaxis-label');
                  let hoveredIndex = null;

                  xaxisLabels.forEach((label, i) => {
                    const r = label.getBoundingClientRect();
                    const left = r.left - rect.left;
                    const top = r.top - rect.top;
                    const right = left + r.width;
                    const bottom = top + r.height;

                    if(mouseX >= left && mouseX <= right && mouseY >= top && mouseY <= bottom) {
                      hoveredIndex = i;
                    }
                  });

                  if (hoveredIndex !== null) {
                    const fullText = config.config.series[0].data[hoveredIndex].processName;
                    tip.textContent = fullText;
                    tip.style.left = (evt.offsetX - tip.offsetWidth / 2) + 'px';
                    tip.style.top = (evt.offsetY - tip.offsetHeight - 5) + 'px';
                    tip.style.opacity = '1';
                  } else {
                    tip.style.opacity = '0';
                  }
                };

                const outHandler = () => tip.style.opacity = '0';

                el.addEventListener('mousemove', moveHandler);
                el.addEventListener('mouseleave', outHandler);

                chartContext.w.config._labelTooltipCleanup = () => {
                  el.removeEventListener('mousemove', moveHandler);
                  el.removeEventListener('mouseleave', outHandler);
                  if (tip.parentNode) tip.parentNode.removeChild(tip);
                };
              },
              destroyed: function(chartContext, config) {
                if(chartContext.w.config._labelTooltipCleanup) chartContext.w.config._labelTooltipCleanup();
              }
            }
          },
        },
      },
    }
  },
  computed: {
    height() {
      return 150 + 20 * this.confirmationsPerDayData.length
    },
    series() {
      return this.confirmationsPerDayData.slice(0, 50)
    },
  }
}
</script>